import { EvacuateSafetyIslandApi } from '@wiz-api/emergency-management'
import {
  map,
  forEach,
  get,
  find,
  concat,
  fromPairs,
  isEmpty,
  findIndex,
  filter,
  reduce,
} from 'lodash'

const areaApi = new EvacuateSafetyIslandApi()

// 生成UUID
const getUUID = () => {
  const tempUrl = URL.createObjectURL(new Blob())
  const uuid = tempUrl.toString()
  URL.revokeObjectURL(tempUrl)
  return uuid.substring(uuid.lastIndexOf('/') + 1)
}
/** ************************************************ 安全岛列表 **************************************** */

// 安全岛绘制实例列表
let riskAreaInstance = []
// 安全岛列表
let riskAreaList = []
// 风险区域图标列表
const areaIconList = []

// 场景id
let sceneId = ''

let cloudRender
let drawHandler

// 初始化数据
const initAreaData = () => {
  riskAreaInstance = []
  riskAreaList = []
  // 风险区域图标列表
  areaIconList.length = 0
  sceneId = ''
  drawHandler = null
}

// 获取安全岛列表
const getAreaList = async (sceneId) => {
  const [err, res] = await areaApi.getPoint({
    sceneId,
  })
  if (!err && res) {
    return res
  }
  return []
}

// 绘制安全岛
const drawRiskArea = async (player, areaDetail) => {
  if (!player.Native) return
  const pos = map(JSON.parse(areaDetail.coordinateJson), (item) => {
    return [item.xIndex, item.yIndex, item.zIndex]
  })
  const baseOptions = {
    name: areaDetail.id,
    pos,
    height: areaDetail.height || 1,
    id: `${getUUID()}_island`,
    editMode: false,
  }
  const styleOptions = {
    type: 'riskArea',
    style: '#07ff0152',
  }

  const areaObject = await cloudRender.ElectoronicRail.createByPosition(baseOptions, styleOptions)
  // 缓存围栏绑定的数据id
  riskAreaInstance.push({ areaId: areaDetail.id, areaObject })
  // 安全岛列表
}

// 绘制标签
const drawMarker = async (player, areaDetail) => {
  if (!player.Native) return
  const background = 'safetyIsland'
  const targetInstance = find(riskAreaInstance, ['areaId', areaDetail.id])
  const areaAabb = await player.Native.ElectoronicRail.getAabb(
    targetInstance?.areaObject?.data?.fenceObject
  )
  const pos = Aabb.faceCenter(areaAabb, 'Z')
  const singleOption = {
    id: `${getUUID()}_islandLabel`,
    pos,
    background,
    visible: true,
    nodeOffset: [0, -50],
    text: '安全岛',
    textColor: '#ffffffff',
    hasTriangle: false,
  }
  const picId = getUUID()
  const pictureOption = {
    id: `${picId}_islandPicLabel`,
    pos,
    backgroundUrl: 'data://../apps/markers/safetyIsland/left.png',
    visible: true,
    nodeOffset: [-37, -48],
    imgSize: [49, 49],
  }
  // 文字
  const textRes = await cloudRender.Marker.createBySingleLine(singleOption)
  if (textRes.status) {
    const data = map(textRes.data, (item) => {
      return {
        id: item,
        dataId: areaDetail.id,
        type: 'single',
        pos
      }
    })
    areaIconList.push(...data)
  }
  // 图片
  const picRes = await cloudRender.Marker.createByPicture(pictureOption)
  if (picRes.status) {
    const data = map(picRes.data, (item) => {
      return {
        id: item,
        dataId: areaDetail.id,
        type: 'picture',
        pos
      }
    })
    areaIconList.push(...data)
  }
}
// 标签事件
const markerClick = (e) => {
  // 左键点击并且有id
  if (e.type === 1 && !isEmpty(e.markerId)) {
    const areaInfo = find(areaIconList, (item) => {
      return item.id === e.markerId
    })
    if (areaInfo) {
      // 移动到视角
      const openEvent = new CustomEvent('openEmergencyDisposalDialog', {
        detail: {
          row: { ...areaInfo, sceneId, id: areaInfo.dataId },
          type: 'SafetyIsland',
        },
      })
      window.dispatchEvent(openEvent)
    }
  }
}
// 安全岛点击事件
const eventSelected = (e) => {
  if (e.fence) {
    const areaInfo = find(riskAreaInstance, ['areaObject.data.fenceObject', e.fence])
    // 不存在选中安全岛
    if (!areaInfo) {
    }
    // 打开某页面？ ..todo
  }
}

// 创建安全岛
const create = async (player, sourceId, propCloudRender) => {
  if (!player.Native) {
    return
  }
  // 初始化数据
  initAreaData()
  cloudRender = propCloudRender
  window.cloudRender = cloudRender
  sceneId = sourceId
  // 获取安全岛列表数据
  drawHandler = new Promise(async (resolve) => {
    riskAreaList = await getAreaList(sourceId)
    // 生成安全岛
    for (let i = 0; i < riskAreaList.length; i += 1) {
      const item = riskAreaList[i]
      // 如果该安全岛已经绘制，则展示区域
      await drawRiskArea(player, item)
      await drawMarker(player, item)
    }
    resolve()
  })
  // 监听安全岛点击事件
  player.Native.ElectoronicRail.EventSelected.connect(eventSelected)
  cloudRender.Dispatch.on('Marker', markerClick)
}

// 更新安全岛（区域改变）暂不分区域
const update = async (player, sourceId, propCloudRender, areaId) => {
  if (!player.Native) {
    return
  }
  // 获取新的安全岛列表数据
  getAreaList(sourceId, areaId).then((newRiskAreaList) => {
    const newRiskAreaIds = map(newRiskAreaList, (i) => {
      return i.id
    })
    // 更新安全岛显隐
    const instanceToUpdate = reduce(
      riskAreaInstance,
      (acc, item) => {
        const action = newRiskAreaIds.includes(item) ? 'show' : 'hidden'
        acc[action].push(item)
        return acc
      },
      { hide: [], show: [] }
    )

    forEach(instanceToUpdate.hide, async (item) => {
      player.Native.ElectoronicRail.setVisible(item.areaObject?.data?.fenceObject, false) // 隐藏
    })
    forEach(instanceToUpdate.show, async (item) => {
      player.Native.ElectoronicRail.setVisible(item.areaObject?.data?.fenceObject, true) // 展示
    })
    const iconInstanceToUpdate = reduce(
      areaIconList,
      (acc, item) => {
        const action = newRouteIds.includes(item.dataId) ? 'show' : 'hide'
        acc[action].push(item)
        return acc
      },
      { hide: [], show: [] }
    )
    cloudRender.Marker.updateBySingleLine(
      map(iconInstanceToUpdate.hide, (i) => {
        return {
          id: i.id,
          visible: false,
        }
      })
    )
    cloudRender.Marker.updateBySingleLine(
      map(iconInstanceToUpdate.show, (i) => {
        return {
          id: i.id,
          visible: true,
        }
      })
    )
  })
}
// 销毁安全岛
const destroy = async (player) => {
  if (!player.Native) {
    return
  }
  await drawHandler
  // 销毁图标
  cloudRender.Marker.destroyMarker(map(areaIconList, 'id'))
  // 销毁安全岛绘制
  cloudRender.ElectoronicRail.destroy(map(riskAreaInstance, 'areaObject.data.id'))
  // 取消标签的事件监听
  cloudRender.Dispatch.off('Marker', markerClick)
  // 取消安全岛事件监听
  player.Native.ElectoronicRail.EventSelected.disconnect(eventSelected)
}

// 切换标签安全岛显示隐藏
const toggleDisplay = async (player, type) => {
  await drawHandler
  // 设置围栏的显隐
  forEach(riskAreaInstance, async (item) => {
    player.Native.ElectoronicRail.setVisible(item.areaObject?.data?.fenceObject, type)
  })
}

// 隐藏安全岛及其标签
const hidden = async (player) => {
  await toggleDisplay(player, false)
}

// 重新显示安全岛及其标签
const display = async (player) => {
  await toggleDisplay(player, true)
}

export { areaIconList }
export default { create, destroy, hidden, display }
